<template>
  <div class="userLog-main-content">
    <div class="search">
      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" :min-width="100" v-model="searchForm.name" placeholder="输入视频名称...."></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">新增</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column align="center" prop="name" label="视频名称" min-width="240"></el-table-column>
        <el-table-column prop="sort" label="排序" min-width="100" align="center">
          <template slot-scope="scope">
            <el-input type="text" v-model.lazy="scope.row.sort" @change="editSort(scope.row)" class="tableSort">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="image" label="封面图片" min-width="150">
          <template v-slot:default="scope">
            <el-image :src="scope.row.image" />
          </template>
        </el-table-column>


        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination :params="pageParams" @pageList="pageList"></Pagination>

    <!-- edit start -->
    <el-dialog style="max-height:80vh;" :title="editTitle" :visible.sync="editFormVisible" width="50%"
      @click="closeDialog">
      <el-form label-width="140px" :model="formData" :rules="rules" ref="formData">

        <el-form-item style="margin-bottom:6px;" label="视频名称" prop="name">
          <el-input size="small" style="width:80%" v-model="formData.name" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="上传封面">
          <el-upload class="avatar-uploader" action="https://epc.yiec.com/apiNQ/api/common/upload"
            :show-file-list="false" :on-success="handleTreeImgSuccess" :before-upload="beforeTreeImgUpload" name="file">
            <img v-if="formData.image" :src="formData.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="上传视频" prop="priceUrl">
          <el-upload class="upload-demo" :limit="1" :multiple="false" drag
            action="https://epc.yiec.com/apiNQ/api/common/upload" :before-upload="beforeVideoUpload"
            :on-success="uploadVideoSuccess" :file-list="videoList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处(只能上传mp4文件)，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('formData')">提交保存</el-button>
          <el-button size="small" @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- edit end -->
  </div>
</template>

<script>
import { gt0 } from '../utils/util';
import { video_page, video_add, video_update, video_update_sort, video_del, user_refresh_token } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";

export default {
  data() {
    return {
      timer: null, // 定时器
      // 页面控制元素
      loading: false, //是否显示加载
      editTitle: '', //编辑页面标题
      editType: 1, // 新增/修改
      editFormVisible: false, // 编辑页面显隐
      // 搜索表单
      searchForm: {
        name: ''
      },
      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      formData: {
        id: '',
        name: '',
        image: '',
        video: ''
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      list: [],
      // 列表
      videoList: []
    };
  },
  // 注册组件
  components: { Pagination },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userlog", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;
      param.name = this.searchForm.name;

      const data = await video_page(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.page(this.pageParams.currentPage - 1, this.pageParams.pageSize);
      } else {
        this.list = data.data.list;
      }
    },

    // ----------------------search end---------------------

    // ----------------------add start---------------------
    handleEdit: function (row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.editTitle = "修改视频";
        this.editType = 2;

        this.formData.id = row.id;
        this.formData.name = row.name;
        this.formData.image = row.image;
        this.formData.video = row.video;
        if (this.formData.video) {
          this.videoList = [JSON.parse(this.formData.video)]
        }
      } else {
        this.editTitle = "新增视频";
        this.editType = 1;

        this.formData.id = "";
        this.formData.name = "";
        this.formData.image = "";
        this.formData.video = "";
      }
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editType == 1) {
            this.add(this.formData);
          }
          else if (this.editType == 2) {
            this.update(this.formData);
          }
          this.editFormVisible = false;
          this.loading = false;
        } else {
          return false;
        }
      });
    },

    //新增 修改
    async add() {
      await video_add(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    async update() {
      await video_update(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },

    clearFormData() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.image = "";
      this.formData.video = "";
      this.videoList = [];
    },
    closeDialog() {
      this.clearFormData();
      this.editFormVisible = false;
    },


    // 修改排序
    async editSort(data) {
      if (!gt0(data.sort)) {
        this.$message({
          message: "请输入大于0的数字！",
          type: "warning"
        });
        return;
      }
      const params = { id: data.id, sort: data.sort };
      await video_update_sort(params);
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);

      this.$message({
        message: "操作成功!",
        type: "success"
      });
    },


    // ----------------------add end-----------------------

    //====================上传封面照片   start  ==============
    // 上传图片 start
    handleTreeImgSuccess(res, file) {
      URL.createObjectURL(file.raw);
      this.formData.image = res.data
    },

    beforeTreeImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      } else {
        return true;
      }
    },


    beforeVideoUpload(file) {
      // ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      // 判断是否是excel
      const isExcel = file.type == 'video/mp4'
      const isLt10M = file.size / 1024 / 1024 <= 100;

      if (!isExcel) {
        this.$message.error('上传视频只能是mp4文件!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过100M!');
      }
      return isExcel && isLt10M;
    },
    uploadVideoSuccess(res, file) {
      URL.createObjectURL(file.raw);
      let param = { name: file.name, url: res.data }
      this.formData.video = JSON.stringify(param);

    },
    // 上传图片 end
    //====================上传封面照片   end  ==============


    // ----------------------delete start-------------------
    // 删除记录
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          video_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(this.pageParams.currentPage, this.pageParams.pageSize);
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------
  }
};
</script>
<style scoped>
.el-image {
  width: 80px;
  height: 80px;
}
</style>





// WEBPACK FOOTER //
// src/views/Video.vue